import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { CommonBookingComponentsModule } from '@fcom/common-booking';
import { UiTranslateModule } from '@fcom/ui-translate';
import { UiComponentsModule } from '@fcom/ui-components';
import { CmsModule } from '@fcom/cms/components';
import { ComponentsModule, DirectiveModule, FinFormsModule, PipesModule } from '@fcom/common';
import { SubViewModule } from '@fcom/common-booking/components/subview/subview.module';
import { CommonServiceFormsModule } from '@fcom/service-forms/components/common/common-service-forms.module';

import { ManageBookingCommonModule } from '../common/booking-common.module';
import { TravelPreparationsGuard } from './services/travel-preparations.guard';
import { ManageBookingTravelPreparationsRouteComponent } from './routes/travel-preparations-route.component';
import { ApisPassengerComponent } from './components/apis-passenger/apis-passenger.component';
import { ApisPaxFormComponent } from './components/apis-pax-form/apis-pax-form.component';
import { ApisGlobalStatusComponent } from './components/apis-global-status/apis-global-status.component';
import { ApisStatusRowComponent } from './components/apis-status-row/apis-status-row.component';
import { ApisPassportComponent } from './components/apis-passport/apis-passport.component';
import { ApisVisaComponent } from './components/apis-visa/apis-visa.component';
import { ApisDestinationComponent } from './components/apis-destination/apis-destination.component';
import { ApisEmergencyContactComponent } from './components/apis-emergency-contact/apis-emergency-contact.component';
import { ApisCountryOfResidenceComponent } from './components/apis-country-of-residence/apis-country-of-residence.component';
import { ApisPurposeOfVisitComponent } from './components/apis-purpose-of-visit/apis-purpose-of-visit.component';

@NgModule({
  imports: [
    CommonModule,
    ComponentsModule,
    CmsModule,
    PipesModule,
    DirectiveModule,
    UiTranslateModule,
    UiComponentsModule,
    ManageBookingCommonModule,
    CommonBookingComponentsModule,
    SubViewModule,
    FinFormsModule,
    CommonServiceFormsModule,
  ],
  declarations: [
    ManageBookingTravelPreparationsRouteComponent,
    ApisPassengerComponent,
    ApisPaxFormComponent,
    ApisGlobalStatusComponent,
    ApisStatusRowComponent,
    ApisPassportComponent,
    ApisCountryOfResidenceComponent,
    ApisVisaComponent,
    ApisDestinationComponent,
    ApisPurposeOfVisitComponent,
    ApisEmergencyContactComponent,
  ],
  exports: [
    ManageBookingTravelPreparationsRouteComponent,
    ApisPassengerComponent,
    ApisCountryOfResidenceComponent,
    ApisPaxFormComponent,
    ApisPassportComponent,
    ApisVisaComponent,
    ApisDestinationComponent,
    ApisEmergencyContactComponent,
    ApisPurposeOfVisitComponent,
  ],
  providers: [TravelPreparationsGuard],
})
export class ManageBookingTravelPreparationsModule {}
